import { inject, unref, watch, type MaybeRef, type Ref } from 'vue'
import type { Message } from '#entities/message'
import { guest, userInjectionKey } from '#shared/index'

export function useScrollToSentMessage(
  scrollerEl: MaybeRef<HTMLElement | null>,
  lastMessage: Ref<Message | undefined>
) {
  const currentUser = inject(userInjectionKey)

  watch(lastMessage, lastMessage => {
    if (!lastMessage) return

    const currentUserVal = unref(currentUser)
    if (!currentUserVal || currentUserVal === guest) return

    if (lastMessage.sender.id === currentUserVal.id && lastMessage.meta?.isFresh) {
      const scrollerElVal = unref(scrollerEl)

      setTimeout(() => {
        scrollerElVal?.scroll({
          behavior: 'smooth',
          top: scrollerElVal.scrollHeight,
        })
      })
    }
  })
}
